<!-- generate-ai-diets.component.html -->
<ion-split-pane contentId="chat-main" class="chat-split-pane" when="false">
  <ion-menu menuId="chat-menu" contentId="chat-main" type="push" side="start" class="chat-sidebar">
    <ion-header class="ion-no-border">
      <ion-toolbar class="sidebar-toolbar">
        <button class="new-chat-btn glass-card" (click)="createNewSession()">
          <div class="btn-inner">
            <div class="icon-circle"><ion-icon name="add"></ion-icon></div>
            <span>New chat</span>
          </div>
        </button>
      </ion-toolbar>
      <div class="search-container">
        <ion-searchbar placeholder="Search chats..." [(ngModel)]="searchQuery" class="sidebar-search"></ion-searchbar>
      </div>
    </ion-header>

    <ion-content class="sidebar-content">
      <div class="sidebar-scroll-area">
        @if (isLoadingHistory) {
          <div class="skeleton-list">
            @for (i of [1, 2, 3, 4, 5]; track i) {
              <div class="skeleton-item glass-card">
                <div class="skeleton-icon"></div>
                <div class="skeleton-text"></div>
              </div>
            }
          </div>
        } @else {
          @if (filteredPinnedSessions.length > 0) {
            <div class="session-group">
              <div class="group-label">Pinned</div>
              <div class="session-list">
                @for (session of filteredPinnedSessions; track session.session_id) {
                  <div class="session-item glass-card" [class.active-session]="session.session_id === currentSessionId" (click)="selectSession(session.session_id)">
                    <div class="session-content">
                      <ion-icon name="pin" class="session-icon pinned"></ion-icon>
                      <span class="session-title">{{ session.title }}</span>
                    </div>
                    <button class="menu-btn" (click)="openSessionMenu($event, session)">
                      <ion-icon name="ellipsis-horizontal"></ion-icon>
                    </button>
                  </div>
                }
              </div>
            </div>
          }

          <div class="session-group">
            <div class="group-label">Recent</div>
            <div class="session-list">
              @if (filteredUnpinnedSessions.length === 0 && filteredPinnedSessions.length === 0) {
                <div class="no-history glass-card">No previous chats</div>
              }
              @for (session of filteredUnpinnedSessions; track session.session_id) {
                <div class="session-item glass-card" [class.active-session]="session.session_id === currentSessionId" (click)="selectSession(session.session_id)">
                  <div class="session-content">
                    <span class="session-title">{{ session.title }}</span>
                  </div>
                  <button class="menu-btn" (click)="openSessionMenu($event, session)">
                    <ion-icon name="ellipsis-horizontal"></ion-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </ion-content>
  </ion-menu>

  <div class="ion-page tracker-theme" id="chat-main">
    <ion-header class="ion-no-border main-header">
      <ion-toolbar class="transparent-toolbar">
        <div class="header-section chat-top-header">
          <div class="header-left">
            <div class="back-btn-wrapper" (click)="goBack()">
              <ion-icon name="chevron-back-outline"></ion-icon>
            </div>
            <ion-menu-button menu="chat-menu" class="custom-menu-btn"></ion-menu-button>
          </div>
          <div class="title-text chat-title-center">
            <h1>{{ currentSessionTitle }}</h1>
          </div>
          <div class="header-right">
            <div class="back-btn-wrapper new-chat-action" (click)="createNewSession()" title="Start New Chat">
              <ion-icon name="create-outline"></ion-icon>
            </div>
          </div>
        </div>
      </ion-toolbar>
    </ion-header>

    <ion-content class="chat-content" #chatContent [scrollEvents]="true" (ionScroll)="onScroll($event)">
      <div class="chat-scroll-container fade-in">
        @if (isLoadingMessages) {
          <div class="messages-loading">
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
          </div>
        } @else {
          @if (currentMessages.length === 0) {
            <div class="welcome-container" [class.has-selection]="selectedCategory">
              <div class="header-illustration glass-orb">
                <div class="glow-orb"></div>
                <div class="sparkle s1">✦</div>
                <div class="sparkle s2">✦</div>
                <ion-icon name="sparkles" class="ai-emoji"></ion-icon>
              </div>
              <h2>How can I help you today?</h2>
              @if (selectedCategory) {
                <div class="dynamic-glass-tabs top-tabs fade-in">
                  <button class="tab-btn" [class.active]="selectedCategory === 'diet'" (click)="selectCategory('diet')">
                    <ion-icon name="restaurant-outline"></ion-icon><span>Diet</span>
                  </button>
                  <button class="tab-btn" [class.active]="selectedCategory === 'recipes'" (click)="selectCategory('recipes')">
                    <ion-icon name="nutrition-outline"></ion-icon><span>Recipes</span>
                  </button>
                  <button class="tab-btn" [class.active]="selectedCategory === 'exercise'" (click)="selectCategory('exercise')">
                    <ion-icon name="fitness-outline"></ion-icon><span>Exercise</span>
                  </button>
                </div>
              }
              @if (selectedCategory) {
                @if (selectedCategory === 'diet') {
                  <div class="plan-duration-notice fade-in">
                    <ion-icon name="information-circle-outline"></ion-icon>
                    <span>Diet plan covers a single day</span>
                  </div>
                }
                @if (selectedCategory === 'exercise') {
                  <div class="plan-duration-notice fade-in">
                    <ion-icon name="information-circle-outline"></ion-icon>
                    <span>Exercise plan covers a single day</span>
                  </div>
                }
                <div class="suggestions-grid fade-in-up">
                  @for (suggestion of currentSuggestions; track $index) {
                    <div class="suggestion-card glass-card"
                         (click)="sendSuggestion(suggestion)">
                      <div class="suggestion-left-icon">
                        <ion-icon [name]="suggestion.icon || 'restaurant-outline'"></ion-icon>
                      </div>
                      <div class="suggestion-text">
                        <span class="suggestion-title">{{ suggestion.title }}</span>
                        <span class="suggestion-prompt">{{ suggestion.prompt }}</span>
                      </div>
                      <div class="suggestion-icon"><ion-icon name="arrow-up"></ion-icon></div>
                    </div>
                  }
                </div>
              }
            </div>
          }

          <div class="messages-container">
            @for (msg of currentMessages; track msg.id) {
              @if (!msg.isStreaming || (msg.isStreaming && msg.content.length > 0)) {
                <div class="message-row" [class.user-row]="msg.role === 'user'" [class.ai-row]="msg.role === 'ai'">
                  <div class="message-content glass-card" [class.user-bubble]="msg.role === 'user'" [class.ai-bubble]="msg.role === 'ai'">

                    @if (msg.content) {
                      <div class="text-content" [innerHTML]="formatMessage(msg.content)"></div>
                    }

                    @if (msg.isValid !== false && msg.isDietJson && msg.dietData && msg.dietData.length > 0) {
                      <div class="diet-widget">
                        <div class="widget-header">
                          <div class="icon-circle" style="background: var(--primary-bg); color: var(--primary);">
                            <ion-icon name="restaurant"></ion-icon>
                          </div>
                          <div class="widget-title">
                            <h4>Personalized Diet Plan</h4>
                            <p>{{ msg.dietData[0]?.day_meal_nutrients?.energy | number: "1.0-0" }} kcal daily target</p>
                          </div>
                        </div>

                        @if (msg.dietData[0]?.day_meal_nutrients; as nutrients) {
                          <div class="macros-grid">
                            <div class="macro-pill calories full-width"><span class="macro-label">Calories</span><span class="macro-val">{{ nutrients.energy | number: "1.0-0" }} <small>kcal</small></span></div>
                            <div class="macro-pill carbs"><span class="macro-label">Carbs</span><span class="macro-val">{{ nutrients.carbs | number: "1.0-1" }} <small>g</small></span></div>
                            <div class="macro-pill protein"><span class="macro-label">Protein</span><span class="macro-val">{{ nutrients.protein | number: "1.0-1" }} <small>g</small></span></div>
                            <div class="macro-pill fat"><span class="macro-label">Fat</span><span class="macro-val">{{ nutrients.fat | number: "1.0-1" }} <small>g</small></span></div>
                            <div class="macro-pill fibre"><span class="macro-label">Fibre</span><span class="macro-val">{{ nutrients.fibre | number: "1.0-1" }} <small>g</small></span></div>
                          </div>
                        }

                        <div class="meals-accordion">
                          @for (meal of msg.dietData[0]?.meal_details; track $index) {
                            @if (meal.meal_nutrients?.energy > 0 || meal.meal_name === "WATER" || meal.meal_name === "Water") {
                              <div class="meal-card glass-card" [class.expanded]="!meal.isCollapsed">
                                <div class="meal-header" (click)="toggleMealCollapse(meal, $event)">
                                  <div class="meal-info">
                                    <span class="meal-name">{{ meal.meal_name }}</span>
                                    <span class="meal-cal">{{ meal.meal_nutrients?.energy | number: "1.0-0" }} kcal</span>
                                  </div>
                                  <div class="collapse-btn">
                                    <ion-icon [name]="meal.isCollapsed ? 'chevron-down-outline' : 'chevron-up-outline'"></ion-icon>
                                  </div>
                                </div>
                                @if (!meal.isCollapsed) {
                                  <div class="meal-body">
                                    <div class="food-list">
                                      @for (food of meal.normalizedFoods; track $index) {
                                        <div class="food-item">
                                          <div class="food-main">
                                            <span class="food-title">{{ food.food_name || food.foodName }}</span>
                                            <span class="food-qty">{{ food.quantity }} {{ food.unit }} @if (food.qty_in_grm) { ({{ food.qty_in_grm }}g) }</span>
                                          </div>
                                          <div class="food-cals"><span>{{ food.food_nutrients?.energy | number: "1.0-0" }} kcal</span></div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          }
                        </div>

                        <div class="diet-actions">
                          <button class="premium-save-btn" (click)="promptSaveDiet(msg.dietData)">
                            <ion-icon name="bookmark" color="light"></ion-icon> Save Diet Plan
                          </button>
                        </div>
                      </div>
                    }

                    @if (msg.isValid !== false && msg.isRecipeJson && msg.recipeData) {
                      <div class="diet-widget">
                        <div class="widget-header">
                          <div class="icon-circle" style="background: var(--primary-bg); color: var(--primary);">
                            <ion-icon name="nutrition"></ion-icon>
                          </div>
                          <div class="widget-title">
                            <h4>{{ msg.recipeData.title || 'Recipe' }}</h4>
                            <p>Healthy Recipe</p>
                          </div>
                        </div>

                        @if (msg.recipeData.nutrition) {
                          <div class="macros-grid recipe-macros-grid">
                            @for (macro of getRecipeMacros(msg.recipeData.nutrition); track macro.label) {
                              <div [class]="'macro-pill ' + macro.cls">
                                <span class="macro-label">{{ macro.label }}</span>
                                <span class="macro-val">{{ macro.value }} <small>{{ macro.unit }}</small></span>
                              </div>
                            }
                          </div>
                        }

                        @if (msg.recipeData.ingredients && msg.recipeData.ingredients.length > 0) {
                          <div class="meal-body" style="padding: 0;">
                            <div class="food-list" style="border-top: none; padding-top: 0;">
                              <div class="food-item" style="flex-direction: column; align-items: flex-start; gap: 8px;">
                                <span class="food-title" style="color: var(--primary);">Ingredients</span>
                                <ul style="margin: 0; padding-left: 20px; font-size: 0.9rem; color: var(--text-muted);">
                                  @for (ing of msg.recipeData.ingredients; track $index) { <li>{{ ing }}</li> }
                                </ul>
                              </div>

                              @if (msg.recipeData.instructions && msg.recipeData.instructions.length > 0) {
                                <div class="food-item" style="flex-direction: column; align-items: flex-start; gap: 8px; margin-top: 12px;">
                                  <span class="food-title" style="color: var(--primary);">Instructions</span>
                                  <ol style="margin: 0; padding-left: 20px; font-size: 0.9rem; color: var(--text-muted);">
                                    @for (inst of msg.recipeData.instructions; track $index) { <li style="margin-bottom: 4px;">{{ inst }}</li> }
                                  </ol>
                                </div>
                              }
                            </div>
                          </div>
                        }

                        @if (msg.recipeData.variations && msg.recipeData.variations.length > 0) {
                          <div class="meal-body" style="padding: 0; margin-top: 12px;">
                            <div class="food-list" style="border-top: 1px dashed var(--border-color, rgba(0,0,0,0.08)); padding-top: 12px;">
                              <div class="food-item" style="flex-direction: column; align-items: flex-start; gap: 8px;">
                                <span class="food-title" style="color: var(--primary);">Other Variations</span>
                                <ul style="margin: 0; padding-left: 20px; font-size: 0.9rem; color: var(--text-muted);">
                                  @for (v of msg.recipeData.variations; track $index) {
                                    <li style="margin-bottom: 4px;">
                                      <strong style="color: var(--text-color, #111);">{{ v.name }}</strong>
                                      @if (v.description) { — {{ v.description }} }
                                    </li>
                                  }
                                </ul>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }

                    @if (msg.isValid !== false && msg.isExerciseJson && msg.exerciseData) {
                      <div class="diet-widget">
                        <div class="widget-header">
                          <div class="icon-circle" style="background: var(--primary-bg); color: var(--primary);">
                            <ion-icon name="fitness"></ion-icon>
                          </div>
                          <div class="widget-title">
                            <h4>{{ msg.exerciseData.title }}</h4>
                            @if (msg.exerciseData.duration) {
                              <p>Duration: {{ msg.exerciseData.duration }}</p>
                            }
                          </div>
                        </div>

                        <div class="meal-body" style="padding: 0;">
                          @for (day of (msg.exerciseData.days || []); track $index) {
                            <div class="food-list" style="border-top: none; padding-top: 0; margin-bottom: 4px;">

                              @if (day.label) {
                                <div style="font-size: 1rem; font-weight: 800; color: var(--primary); padding: 12px 0 4px; letter-spacing: 0.3px;">
                                  {{ day.label }}
                                </div>
                              }

                              @if (day.warmup && day.warmup.length > 0) {
                                <div class="food-item" style="flex-direction: column; align-items: flex-start; gap: 8px;">
                                  <span class="food-title" style="color: var(--primary);">Warm-Up</span>
                                  <ul style="margin: 0; padding-left: 20px; font-size: 0.9rem; color: var(--text-muted);">
                                    @for (wu of day.warmup; track $index) { <li>{{ wu }}</li> }
                                  </ul>
                                </div>
                              }

                              @if (day.workout && day.workout.length > 0) {
                                <div class="food-item" style="flex-direction: column; align-items: flex-start; gap: 8px; margin-top: 12px;">
                                  <span class="food-title" style="color: var(--primary);">Main Workout</span>
                                  <ul style="margin: 0; padding-left: 20px; font-size: 0.9rem; color: var(--text-muted);">
                                    @for (wo of day.workout; track $index) { <li>{{ wo }}</li> }
                                  </ul>
                                </div>
                              }

                              @if (day.cooldown && day.cooldown.length > 0) {
                                <div class="food-item" style="flex-direction: column; align-items: flex-start; gap: 8px; margin-top: 12px;">
                                  <span class="food-title" style="color: var(--primary);">Cool Down</span>
                                  <ul style="margin: 0; padding-left: 20px; font-size: 0.9rem; color: var(--text-muted);">
                                    @for (cd of day.cooldown; track $index) { <li>{{ cd }}</li> }
                                  </ul>
                                </div>
                              }
                            </div>
                          }
                        </div>

                        <div class="diet-actions" style="margin-top: 16px;">
                          <button class="premium-save-btn" (click)="promptSaveExercise(msg.exerciseData)">
                            <ion-icon name="bookmark" color="light"></ion-icon> Save Exercise Plan
                          </button>
                        </div>
                      </div>
                    }

                    @if (msg.role === 'ai' && msg.isValid !== false && msg.suggestedPrompts && msg.suggestedPrompts.length > 0) {
                      <div class="suggested-prompts-container fade-in">
                        <span class="prompt-header">You can also ask:</span>
                        <div class="prompts-vertical-stack">
                          @for (prompt of msg.suggestedPrompts; track $index) {
                            <button class="stacked-prompt-btn glass-card" (click)="sendSuggestion({prompt: prompt})">
                              <div class="sparkle-icon"><ion-icon name="sparkles"></ion-icon></div>
                              <span class="prompt-text">{{ prompt }}</span>
                              <ion-icon name="arrow-forward-outline" class="arrow-icon"></ion-icon>
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>

                  @if (msg.role === "user") {
                    <div class="user-actions">
                      <button class="edit-btn" (click)="editPrompt(msg)" title="Edit prompt">
                        <ion-icon name="create-outline"></ion-icon>
                      </button>
                    </div>
                  }

                  @if (msg.role === "ai" && !msg.isStreaming && msg.isValid !== false) {
                    <div class="feedback-container">
                      <button class="feedback-btn" (click)="copyToClipboard(msg)" title="Copy Response">
                        <ion-icon name="copy-outline"></ion-icon> Copy
                      </button>

                      @if (msg.itemRef && !isRegenerateDisabled(msg)) {
                        <button class="feedback-btn regenerate-btn"
                                (click)="regenerateResponse(msg)"
                                title="Regenerate Response">
                          <ion-icon name="refresh-outline"></ion-icon>
                          Regenerate
                        </button>
                      }

                      @if (msg.isDietJson && msg.dietData && msg.dietData.length > 0) {
                        <button class="feedback-btn download-icon-btn" (click)="downloadDietPdf(msg.dietData)" title="Download Diet PDF">
                          <ion-icon name="download-outline"></ion-icon> Download
                        </button>
                      }
                      @if (msg.isRecipeJson && msg.recipeData) {
                        <button class="feedback-btn download-icon-btn" (click)="downloadRecipePdf(msg)" title="Download Recipe PDF">
                          <ion-icon name="download-outline"></ion-icon> Download
                        </button>
                      }
                      @if (msg.isExerciseJson && msg.exerciseData) {
                        <button class="feedback-btn download-icon-btn" (click)="downloadExercisePdf(msg)" title="Download Exercise PDF">
                          <ion-icon name="download-outline"></ion-icon> Download
                        </button>
                      }
                    </div>
                  }
                </div>
              }
            }

            @if (isTyping && !hasStreamingContent) {
              <div class="message-row ai-row">
                <div class="message-content ai-bubble glass-card">
                  <div class="typing-indicator-container">
                    <span class="loading-phrase">{{ currentLoadingPhrase }}</span>
                    <div class="typing-indicator">
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>

      <ion-fab vertical="bottom" horizontal="end" slot="fixed" class="scroll-bottom-fab" [class.show]="showScrollButton">
        <ion-fab-button size="small" class="ios-fab-btn" (click)="scrollToBottomManually()">
          <ion-icon name="arrow-down"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    </ion-content>

    <ion-footer class="chat-footer ion-no-border tracker-theme">
      <div class="footer-inner">
        @if (isTyping) {
          <div class="stop-container">
            <button class="stop-btn glass-pill" (click)="stopGenerating()">
              <ion-icon name="stop-circle-outline"></ion-icon> Stop generating
            </button>
          </div>
        }

        <div class="input-pill glass-card">
          <ion-textarea auto-grow="true" rows="1" max-rows="5"
                        placeholder="Type your message here..."
                        [(ngModel)]="chatInput"
                        (keydown.enter)="onEnterPressed($event)"
                        class="chat-textarea"
                        [disabled]="isLoadingMessages || isLoadingHistory"></ion-textarea>
          <button class="send-btn" [class.active]="chatInput.trim().length > 0"
                  [disabled]="chatInput.trim().length === 0 || isTyping || isLoadingMessages || isLoadingHistory"
                  (click)="sendMessage()">
            <ion-icon name="arrow-up" color="light"></ion-icon>
          </button>
        </div>
        <div class="disclaimer">Not every AI Response will be perfect.</div>
      </div>
    </ion-footer>
  </div>
</ion-split-pane>

<!-- ===================================================== -->
<!-- ========== CUSTOM DATE PICKER MODAL (REDESIGNED) ===== -->
<!-- ===================================================== -->
<ion-modal [isOpen]="isDatePickerModalOpen" (didDismiss)="cancelSaveDate()" class="date-picker-modal" [initialBreakpoint]="1" [breakpoints]="[0, 1]">
  <ng-template>
    <!-- Custom Green Header -->
    <div class="custom-modal-header">
      <div class="header-left">
        <div class="header-icon-circle">
          <ion-icon name="calendar-outline" color="light"></ion-icon>
        </div>
        <div class="header-text">
          <h2>Select Date</h2>
        </div>
      </div>
      <button class="header-close-btn"
              [disabled]="isSavingDate"
              (click)="cancelSaveDate()">
        <ion-icon name="close-outline" color="light"></ion-icon>
      </button>
    </div>

    <ion-content class="date-picker-content ion-padding">
      @if(isFetchingDates) {
        <div class="loading-dates-wrapper">
          <ion-spinner name="crescent" color="primary"></ion-spinner>
          <p>Checking available dates...</p>
        </div>
      } @else {
        <!-- Fail-closed banner: existing plan dates could not be loaded -->
        @if (datePickerLoadFailed) {
          <div class="date-picker-error-banner fade-in" role="alert">
            <ion-icon name="alert-circle-outline"></ion-icon>
            <span>
              Could not load existing plan dates. Please close this dialog and try again —
              saving now may double-book a date that is already taken.
            </span>
          </div>
        }

        <!-- Calendar Card -->
        <div class="bento-card calendar-card">

          <!-- CUSTOM MONTH/YEAR NAVIGATION HEADER -->
          <div class="custom-calendar-header">
            <div class="month-year-selector">
              <button class="nav-arrow"
                      [disabled]="!canGoPrevMonth"
                      (click)="prevMonth()">
                <ion-icon name="chevron-back-outline"></ion-icon>
              </button>
              <span class="current-month-year">{{ currentMonthName }} {{ currentYear }}</span>
              <button class="nav-arrow"
                      [disabled]="!canGoNextMonth"
                      (click)="nextMonth()">
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </button>
            </div>
          </div>

          <!-- Weekdays Header Row -->
          <div class="calendar-grid days-header">
            <div>Sun</div><div>Mon</div><div>Tue</div><div>Wed</div><div>Thu</div><div>Fri</div><div>Sat</div>
          </div>

          <!-- Custom Calendar Grid -->
          <div class="custom-calendar-grid">
            @for (day of calendarDays; track $index) {
              <div
                class="calendar-day-cell"
                [class.empty]="!day.date"
                [class.highlighted]="day.isHighlighted"
                [class.selected]="day.isSelected"
                [class.today]="day.isToday"
                [class.disabled]="day.date && isPastDate(day.date)"
                (click)="day.date && !isPastDate(day.date) && selectDate(day.date)">

                @if (day.date) {
                  <span class="day-number">{{ day.date.getDate() }}</span>
                }
              </div>
            }
          </div>

          <!-- Legend (mirrors design) -->
          <div class="predictions-legend">
            <div class="legend-item">
              <div class="legend-icon-circle red">
              </div>
              <div class="legend-text">
                <strong>Unavailable</strong>
                <small>Plan already assigned</small>
              </div>
            </div>
            <div class="legend-divider"></div>
            <div class="legend-item">
              <div class="legend-icon-circle blue">
                <ion-icon name="time"></ion-icon>
              </div>
              <div class="legend-text">
                <strong>Today</strong>
                <small>{{ today | date:'MMM d' }}</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Button -->
        <div class="date-picker-actions">
          <button class="confirm-schedule-btn"
                  [disabled]="isSavingDate || isFetchingDates || datePickerLoadFailed"
                  (click)="confirmSaveDate()">
            @if (isSavingDate) {
              <ion-spinner name="crescent" color="light"></ion-spinner>
              <span>Saving...</span>
            } @else {
              <span>Confirm Schedule</span>
              <ion-icon name="arrow-forward-outline" color="light"></ion-icon>
            }
          </button>
        </div>
      }
    </ion-content>
  </ng-template>
</ion-modal>
